import React from 'react';
import styled from 'styled-components';
import { COLORS } from '@avalara/bat-apps-shared/lib/constants';
import { SIcon } from '@avalara/skylab-sdk/react';
import BuyButton from '../buy-button';
import { FormContainer } from '../styled/forms';
const nextSteps = [
    'Your free trial starts immediately after you sign up',
    'Limited to 5 orders and 5 invoices per minute, with a daily max of 1,000 total transactions',
    'No-hassle trial ends automatically after 90 days',
];
const LightGreenIcon = styled(SIcon) `
  color: ${COLORS.lightGreen};
`;
const FreeTrialReview = () => (React.createElement(FormContainer, null,
    React.createElement("h1", { className: 'pad-bottom-md' }, "Review your order"),
    React.createElement("p", null,
        "Your ",
        React.createElement("strong", null, "90-day AvaTax Free Trial"),
        " is almost ready."),
    React.createElement("p", { className: 'font-bold margin-top-sm pad-bottom-sm' }, "What you get"),
    nextSteps.map((step, i) => (React.createElement("p", { key: `nextstep${i}` },
        React.createElement(LightGreenIcon, { name: 'check', className: 'margin-right-sm' }),
        step))),
    React.createElement("p", { className: 'margin-top-md' }, "This trial is for new customers only and is not renewable. Upgrade to a paid AvaTax subscription at any time for uninterrupted access."),
    React.createElement(BuyButton, null)));
export default FreeTrialReview;
